import React, { FunctionComponent } from 'react';
import { Form } from '../../../../store/modules/application/types';
import { Person } from '../../../../store/modules/person/types';
import Loader from '../../../../components/Loader';
import FormDisplay from '../../../../components/FormDisplay';

type PersonDataProps = {
    isLoading: boolean;
    person: Person;
    updatePerson: Function;
    editForm: Form;
};

const PersonData: FunctionComponent<PersonDataProps> = (props) => {
    const { person, editForm, isLoading, updatePerson } = props;

    const handleSave = (updatedPerson: Person) => {
        updatePerson(updatedPerson, person.id);
    };
    if (isLoading) return <Loader />;

    return <FormDisplay form={editForm} record={person} handleSave={handleSave} />;
};

export default PersonData;
